export default __webpack_public_path__ + "static/favicon-d9e755cf22fd5eb90de6939cdd35495c.ico";